/* SECCO · nuevo drop: entrada con contador, luz que sigue al dedo o al ratón, foto que se abre y galería con parallax.
   DROPFX.mount(root) al entrar en #/drop y DROPFX.clear() al salir. */
window.DROPFX = (() => {
  const rm = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const clamp = (v, a, b) => v < a ? a : v > b ? b : v;
  const ease = t => t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  let offs = [], raf = 0, alive = false;
  const listen = (el, ev, f, o) => { el.addEventListener(ev, f, o); offs.push(() => el.removeEventListener(ev, f, o)); };

  /* entrada: contador 000→100 y la pantalla negra se cierra sobre una línea de luz */
  function intro(root) {
    const el = root.querySelector("#dmIntro"), n = root.querySelector("#dmCount"); if (!el) return;
    // solo la primera vez en cada visita
    let seen = false; try { seen = sessionStorage.getItem("dm_intro") === "1"; sessionStorage.setItem("dm_intro", "1"); } catch (e) {}
    if (rm || seen) { el.remove(); return; }
    document.body.classList.add("dm-lock");
    const t0 = performance.now(), D = 1300;
    const step = now => {
      if (!alive) return;
      const k = clamp((now - t0) / D, 0, 1);
      n.textContent = String(Math.round(ease(k) * 100)).padStart(3, "0");
      el.style.setProperty("--k", k.toFixed(3));
      if (k < 1) requestAnimationFrame(step);
      else { el.classList.add("out"); document.body.classList.remove("dm-lock"); setTimeout(() => el.remove(), 1100); }
    };
    requestAnimationFrame(step);
    listen(el, "click", () => { el.classList.add("out"); document.body.classList.remove("dm-lock"); setTimeout(() => el.remove(), 900); });
  }

  /* la foto está a oscuras y el ratón (o el dedo) hace de foco de estudio */
  function spotlight(root) {
    const hero = root.querySelector("#dmHero"), hint = root.querySelector("#dmHint"); if (!hero) return;
    let x = .62, y = .38, tx = x, ty = y, user = false, t = 0;
    const set = (cx, cy) => { const r = hero.getBoundingClientRect(); tx = clamp((cx - r.left) / r.width, 0, 1); ty = clamp((cy - r.top) / r.height, 0, 1); if (!user) { user = true; hint && hint.classList.add("off"); } };
    listen(hero, "pointermove", e => set(e.clientX, e.clientY));
    listen(hero, "touchmove", e => { const p = e.touches[0]; set(p.clientX, p.clientY); }, { passive: true });
    const loop = () => {
      if (!alive) return;
      t += .006;
      if (!user) { tx = .58 + Math.sin(t * 1.3) * .16; ty = .36 + Math.cos(t) * .12; }
      x += (tx - x) * .09; y += (ty - y) * .09;
      hero.style.setProperty("--x", (x * 100).toFixed(2) + "%");
      hero.style.setProperty("--y", (y * 100).toFixed(2) + "%");
      raf = requestAnimationFrame(loop);
    };
    loop();
  }

  /* scroll: foto que se abre entre las dos frases y galería con distintas velocidades */
  function onScroll(root) {
    const sec = root.querySelector("#dmOpen"), st = sec && sec.querySelector(".dm-open__stage");
    const figs = [...root.querySelectorAll("#dmGal figure")];
    const narrow = innerWidth < 700;
    const f = () => {
      if (sec) {
        const span = sec.offsetHeight - innerHeight, p = span > 0 ? clamp(-sec.getBoundingClientRect().top / span, 0, 1) : 1, k = rm ? 1 : ease(clamp(p / .7, 0, 1));
        st.style.setProperty("--cy", ((1 - k) * (narrow ? 22 : 18)).toFixed(2) + "%");
        st.style.setProperty("--cx", ((1 - k) * (narrow ? 16 : 36)).toFixed(2) + "%");
        st.style.setProperty("--wo", clamp(1 - k * 1.8, 0, 1).toFixed(3));
        st.style.setProperty("--co", clamp((p - .62) / .25, 0, 1).toFixed(3));
      }
      if (!rm) figs.forEach(fg => { const r = fg.getBoundingClientRect(); if (r.bottom < -200 || r.top > innerHeight + 200) return; const c = (r.top + r.height / 2 - innerHeight / 2); fg.firstElementChild.style.transform = `translate3d(0,${(c * +fg.dataset.sp).toFixed(1)}px,0)`; });
    };
    listen(window, "scroll", () => requestAnimationFrame(f), { passive: true });
    listen(window, "resize", f);
    f();
  }

  function mount(root) {
    clear(); alive = true; intro(root); spotlight(root); onScroll(root);
    listen(root, "click", e => { const j = e.target.closest("[data-dm-join],[data-dm-shop]"); if (j) { e.preventDefault(); root.querySelector(j.hasAttribute("data-dm-shop") ? "#dmShop" : "#dmJoin").scrollIntoView({ behavior: "smooth" }); } });
  }
  function clear() { alive = false; cancelAnimationFrame(raf); offs.forEach(o => o()); offs = []; document.body.classList.remove("dm-lock"); }
  return { mount, clear };
})();
